<template>
    <div class="bg-white dark:bg-gray-800">
        <Hero :hero="params"></Hero>
        <Breadcrumbs :breadcrumbs="crumbs" :page="pagename"></Breadcrumbs>
        <div class="container-y grid gap-4 grid-cols-1 md:grid-cols-[3fr_5fr] lg:grid-cols-[2fr_5fr]">
            <div class="menu order-2 md:order-1">
                <ProfileMenu></ProfileMenu>
            </div>
            <div class="content order-1 md:order-2">
                 <Content></Content>
            </div>
        </div>       
    </div>
</template>

<script>
import Breadcrumbs from '../layouts/breadcrumb.vue'
import Hero from '../layouts/Hero.vue'
import Content from '../components/Other/ContentSejarah.vue'
import ProfileMenu from '../layouts/profileMenu.vue'
export default {
    name: 'ClientSejarahView',

    data() {
        return {
            params:{},
            pagename: 'Sejarah Perusahaan',
            crumbs: [],
            pageparams: 'General'
        };
    },

    mounted() {
        this.getparams()
    },

    methods: {
         getparams(){
             this.axios.get('api/getbanner/'+this.pageparams).then((response) => {
               this.params = {
                    id: response.data.id,
                    title: 'Sejarah Perusahaan',
                    img: response.data.imagepath,
                    showtitle : response.data.showtitle,
                    showdesc : response.data.showdesc,
                }

                document.title =' Sejarah | Bank Padma'
                document.querySelector('head meta[name="description"]').setAttribute('content', response.data.description);
                document.querySelector('head meta[name="og:description"]').setAttribute('content', response.data.description);
                document.querySelector('head meta[name="og:title"]').setAttribute('content', 'Sejarah | Bank Padma');
                document.querySelector('head meta[name="keywords"]').setAttribute('content', response.data.keyword);
                document.querySelector('head meta[name="og:url"]').setAttribute('content', window.location.href);
                document.querySelector('head meta[name="og:image"]').setAttribute('content', response.data.imagepath);
            }).catch(error => {
                
            console.log(error)

            }).finally(() => {
                
            })
            
            this.crumbs = [{key:"Sejarah Perusahaan", link:"/sejarah"}]
        }
    },
    components:{
        Hero,
        Breadcrumbs,
        Content,
        ProfileMenu
    }
};
</script>

<style lang="scss" scoped>

</style>